import "@rmwc/fab/styles";
import { Icon } from "@rmwc/icon";
import "@rmwc/icon/styles";
import { Modale } from "App/Modale/Components/Modale";
import moment from "moment";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./ModaleInfosTranches.css";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher le choix du mode de paiement
 * @category Achat
 */
function ModaleInfosTranches(props) {
  //#region INITIALISATION
  // Récupération des props
  const {
    onClose,
    service,
    visible
  } = props;

  // Traduction i18n
  const { t } = useTranslation();
  // #endregion

  // #region INTERFACE
  // Grouper les tranches par période (date + heures)
  const groupedTranches = service?.tarif?.tranches?.reduce((acc, item) => {
    const key = `${item.dateDebut}_${item.dateFin}_${item.periodeDebut}_${item.periodeFin}`;
    if (!acc[key]) {
      acc[key] = {
        dateDebut: item.dateDebut,
        dateFin: item.dateFin,
        periodeDebut: item.periodeDebut,
        periodeFin: item.periodeFin,
        paliers: []
      };
    }
    acc[key].paliers.push({
      uniteMin: item.uniteMin,
      uniteMax: item.uniteMax,
      prix: item.prix,
      idTranche: item.idTranche
    });
    return acc;
  }, {}) || {};

  const trancheItem = (groupKey, group) => (
    <div key={groupKey} className="ModaleInfosTranches-Card">
      {/* En-tête avec les dates */}
      <div className="ModaleInfosTranches-Card-Header">
        <div className="ModaleInfosTranches-Card-DateRange">
          <Icon icon="event" className="ModaleInfosTranches-Card-Icon" />
          <span>
            {moment(group.dateDebut).format("DD/MM/YYYY")}
            {group.dateFin && ` - ${moment(group.dateFin).format("DD/MM/YYYY")}`}
          </span>
        </div>
        <div className="ModaleInfosTranches-Card-TimeRange">
          <Icon icon="schedule" className="ModaleInfosTranches-Card-Icon" />
          <span>{group.periodeDebut} - {group.periodeFin}</span>
        </div>
      </div>

      {/* Paliers de prix */}
      <div className="ModaleInfosTranches-Card-Body">
        <div className="ModaleInfosTranches-Card-Label">
          {t("achat.paliersTarifs") || "Tarifs par quantité"}
        </div>
        {group.paliers.map((palier, index) => {
          const libelleWithoutFirstWord = service.tarif.libelleType.split(' ').slice(1).join(' ');
          return (
            <div key={palier.idTranche} className="ModaleInfosTranches-Card-Palier">
              <div className="ModaleInfosTranches-Card-Quantity">
                <span className="ModaleInfosTranches-Card-Badge">Tranche {index + 1} :</span>
                <span>
                  {palier.uniteMin === palier.uniteMax
                    ? `${palier.uniteMin} ${libelleWithoutFirstWord}`
                    : palier.uniteMax
                      ? `${palier.uniteMin} - ${palier.uniteMax} ${libelleWithoutFirstWord}`
                      : `${palier.uniteMin}+ ${libelleWithoutFirstWord}`
                  }
                </span>
              </div>
              <div className="ModaleInfosTranches-Card-Price">
                <span className="ModaleInfosTranches-Card-PriceValue">{palier.prix}</span>
                <span className="ModaleInfosTranches-Card-Currency">{service.tarif.symbole}</span>
                <span className="ModaleInfosTranches-Card-Unit">/ {libelleWithoutFirstWord}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    !service || !visible
      ?
      null
      :
      <Modale
        height="600"
        onClose={onClose}
        title={t("achat.modaleTarifs")}
        visible={visible}
        width="400"
      >
        <div className="ModaleInfosTranches-Container">
          {Object.entries(groupedTranches).map(([key, group]) =>
            trancheItem(key, group)
          )}
        </div >
      </Modale >
  );
  // #endregion
};
// #endregion

// #region PROPRIETES
/**
 * Type des propriétés de {@link ModaleInfosTranches}
 * @typedef {Object} ModaleInfosTranches.propTypes
 * @property {function} onClose Fonction callback sur fermeture de la modale
 * @property {object} service Informations du service
 * @property {boolean} visible True pour afficher la modale, false sinon
*/
ModaleInfosTranches.propTypes = {
  onClose: PropTypes.func.isRequired,
  service: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
};
// #endregion

export { ModaleInfosTranches };

